var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cancellation-container"},[(_vm.$loginState())?_c('iframe',{ref:"frame",attrs:{"src":_vm.url,"title":"账号注销"},on:{"load":_vm.sendToken}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }